module.exports = __webpack_public_path__ + "img/empty-zones-background.89ba6263.svg";